import { MeasureType } from '@ps20-frontend/frontend-models';
import {
  UwContextDescriptor,
  UwContextEntry,
  UwSharedDecision,
} from './uw-context.model';

export function foldUploadedFileIds(
  entries: UwContextEntry[],
  descriptors: UwContextDescriptor[],
): string[] | null | undefined {
  const applicableEntries = entries.filter(entry =>
    entry.isRequired && descriptors.some(descriptor => descriptor.key === entry.contextKey),
  );

  const wasAnyContextRejected = applicableEntries.some(entry => entry.willUnderwrite === false);

  const uploadedFileIds = applicableEntries
    .filter(entry => entry.willUnderwrite !== false)
    .flatMap(entry => entry.files.map(file => file.uploadId));

  if (uploadedFileIds.length > 0) {
    return uploadedFileIds;
  }
  if (wasAnyContextRejected) {
    return null;
  }
  return undefined;
}

export interface UwWireDecision {
  zusage: boolean | null;
  name: string;
  zusageDatum: string;
  bensl: string;
  begruendungsText: string;
}

export function buildUwWireDecision(
  entry: UwContextEntry | undefined,
  shared: UwSharedDecision | undefined,
): UwWireDecision | undefined {
  const isDecided = entry?.willUnderwrite !== null && entry?.willUnderwrite !== undefined;
  if (!entry || !shared || (!entry.reason && !isDecided) || (!entry.isRequired && !isDecided)) {
    return undefined;
  }
  return {
    zusage: entry.willUnderwrite,
    name: shared.underwriterName,
    zusageDatum: shared.timestamp,
    bensl: shared.underwriterBensl,
    begruendungsText: shared.documentation,
  };
}

export function findUwZuschlagProzent(shared: UwSharedDecision): number | undefined {
  return shared.measures.find(massnahme => massnahme.type === MeasureType.ZUSCHLAG)
    ?.zuschlagProzent;
}

export function findUwVereinbarungText(shared: UwSharedDecision): string | undefined {
  return shared.measures.find(
    massnahme => massnahme.type === MeasureType.INDIVIDUELLE_VEREINBARUNG,
  )?.vereinbarungText;
}
